import firebase from 'firebase/app'
import 'firebase/firestore'
import Vue from 'vue'
import { APIConnect } from "./APIConnect"
import { Common } from '@/js/common.js'
import { Logger } from '@/js/utils/Logger.js'
import config from 'config'




export default class OptionManager {
    constructor() {
      this.itemList = [];
      this.genreList = [];
      this.favoriteList = [];
      this.recommend = []
      if( config.isDebug ){
        this.recommend = [50, 100]
      }else{
        this.recommend = []
      }
    }
    async update() {
      Logger.info("OptionManager:update");

      // 初期化
      this.itemList.splice(0);
      this.favoriteList.splice(0);

      // 変数のリアクティブ化
      Vue.set(this.itemList);
      Vue.set(this.favoriteList);


      console.log("OptionManager:getItemList");
      await this.getItemList();

      await this.getFBFavoriteData();
      Logger.debug(this.favoriteList);
    }

    async deleteAll(){
      await this.allDeleteFBFavoriteData()
    }

    async delete( tempId ) {
      await this.deleteFBFavoriteData(tempId)
    }

    async addFavoriteData( productId ){
      const favoriteData = {
        uid: firebase.auth().currentUser.uid,
        productId: productId,
        createDate: new Date(),
      }

      await this.addFBFavoriteData(favoriteData);

      this.favoriteList.push(favoriteData);
      // Vue.set(this.favoriteList);
      // Vue.set(this.itemList);
    }

    async getFBFavoriteData(){
      const ref = firebase.firestore().collection("AcryProFavoriteOption");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).get();

      for( let i = 0; i<snapshot.docs.length; ++i ){
        const data = snapshot.docs[i].data();
        const obj =
          {
            uid: data.uid,
            productId: data.productId,
            createDate: data.createDate,
          };
          Vue.set(this.favoriteList, i, obj);
      }
    }

    async addFBFavoriteData(data){
      await firebase.firestore().collection("AcryProFavoriteOption").add(data);
    }

    async deleteFBFavoriteData( productId ){
      const ref = firebase.firestore().collection("AcryProFavoriteOption");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).where("productId", "==", productId).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProFavoriteOption").doc(doc.id).delete().then(() => {
          console.log("Document successfully deleted!");
          const index = this.favoriteList.findIndex( item => item.productId == productId );
          this.favoriteList.splice(index, 1);
          // Vue.set(this.favoriteList);
          // Vue.set(this.itemList);
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }

    async allDeleteFBFavoriteData(){
      const ref = firebase.firestore().collection("AcryProFavoriteOption");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).get();
      for( const doc of snapshot.docs ){
        await firebase.firestore().collection("AcryProFavoriteOption").doc(doc.id).delete().then(() => {
          console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
    }


    async getItemList(){

      // サーバーからオプション品一覧を取得
      let response = await this.apiGetOptionList();

      let csvText = await this.getCSVOptionData();

      // 改行ごとに配列化
      csvText = csvText.replace(/\r\n/g,'');
      let lines = csvText.split(/,(?! )/);

      const ColumnNum = 7;

      this.itemList.splice(0);

      for( let i=1; i<(lines.length/ColumnNum); ++i ){
        let code = lines[i*ColumnNum + 0];
        let name = lines[i*ColumnNum + 1];
        let costPrice = parseInt(lines[i*ColumnNum + 2]);
        //let genre = lines[i*ColumnNum + 3];
        let subGenre = lines[i*ColumnNum + 4];
        let url = lines[i*ColumnNum + 5];
        let info = lines[i*ColumnNum + 6];

        if( !code ){
          continue;
        }

        let product = null
        for (let [key, value] of Object.entries(response.products)) {
          if( value.product_code == code ){
            product = value;
            product.key = key;
          }
        }

        if( !product ){
          continue;
        }

        // 消費税
        const tax = 1.0 + Common.getTax();

        // 一律で原価にかける料金
        const rate = Common.getOptionPriceRate();

        const priceBase = parseInt(costPrice * rate)
        const price = parseInt(priceBase * tax)

        this.itemList.push({
          productId:product.product_id,
          productClassId:product.product_class_id,
          productCode:code,
          subGenre:subGenre,
          price:price,
          priceBase:priceBase,
          title:name,
          info:info,
          imageUrl:url,
        });
      }

      // 各ジャンルとサブジャンルを定義
      this.genreList = 
      [
        { genreName:"OPP袋", subGenre:[{subGenreName:"OPP袋"}]},
        { genreName:"キーホルダー", subGenre:[{subGenreName:"ワンタッチ型"}, {subGenreName:"二重リング型"}, {subGenreName:"模様二重リング型"}, {subGenreName:"カギ型"}, {subGenreName:"馬蹄（バテイ)型"}, {subGenreName:"ワイヤー型"}]},
        { genreName:"ボールチェーン・鎖", subGenre:[{subGenreName:"ボールチェーン"}]},
        { genreName:"キーフック", subGenre:[{subGenreName:"キーフック"}]},
        { genreName:"カニカン", subGenre:[{subGenreName:"ステンレス製"}, {subGenreName:"真鍮製"}, {subGenreName:"ダイキャスト製"}]},
        { genreName:"スナップフック", subGenre:[{subGenreName:"Sシリーズ"}, {subGenreName:"Mシリーズ"}, {subGenreName:"Lシリーズ"}, {subGenreName:"ミニシリーズ"}, {subGenreName:"フック S-1 シリーズ"}, {subGenreName:"真鍮スナップフック"}, {subGenreName:"チャームフック"}]},
        { genreName:"カラビナ", subGenre:[{subGenreName:"アルミカラビナ"}, {subGenreName:"ダイキャストカラビナ"}]},
        { genreName:"二重リング", subGenre:[{subGenreName:"巻き放し"}, {subGenreName:"丸押し"}, {subGenreName:"三角押し"}, {subGenreName:"平角押し"}, {subGenreName:"模様押し"}]},
        { genreName:"カン各種", subGenre:[{subGenreName:"丸カン"}, {subGenreName:"Dカン"}, {subGenreName:"回転カン（シーベル）"}]},
        { genreName:"根付紐", subGenre:[{subGenreName:"クラシックカラー"}, {subGenreName:"パステルカラー"}, {subGenreName:"2色編み"}, {subGenreName:"多色編み"}, {subGenreName:"銀糸・金糸根付"}, {subGenreName:"メタリック根付"}, {subGenreName:"ミニ根付紐"}, {subGenreName:"ミニストラップ根付"}, {subGenreName:"ちりめん根付"}, {subGenreName:"クラウン根付"}]},
        { genreName:"ストラップ", subGenre:[{subGenreName:"定番松葉ストラップ"}, {subGenreName:"フック付き松葉ストラップ"}, {subGenreName:"ビーズストラップ"}]},
        { genreName:"ピン・バッジ", subGenre:[{subGenreName:"マグネットバッジ"}]},
        { genreName:"安全ピン付きパーツ・クリップ", subGenre:[{subGenreName:"クリッキー"}, {subGenreName:"ノーリツピン・フックピン"}, {subGenreName:"スタンドパーツ"}, {subGenreName:"樹脂クリップ"}]},
        { genreName:"飾り・チャーム", subGenre:[{subGenreName:"アルファベットチャーム"}]},
      ];

      // そのジャンルに関連するオプション品を集計
      this.genreList.forEach(genre => {
        var sum = 0;
        for( var i=0; i<genre.subGenre.length; ++i ){
          var num = this.itemList.filter((item)=>{return item.subGenre == genre.subGenre[i].subGenreName}).length;
          sum += num;
          genre.subGenre[i].num = num;
        }
        genre.num = sum;
      });

      // for( let i=0; i<this.genreList.length; ++i ){
      //   // Vue.set(this.genreList, i, this.genreList[i]);
      // }

      return;


      // return [
      //   { productId: "40", price: 137, subGenre: "ジャンル1_a", title: "ワンタッチキーホルダー", subTitle: "" },
      //   { productId: "39", price: 182, subGenre: "ジャンル1_a", title: "ワイヤーキーホルダー(丸カン別売)", subTitle: "" },
      //   { productId: "35", price: 91, subGenre: "ジャンル1_b", title: "丸カン (5pcs)", subTitle: "" },
      //   { productId: "36", price: 46, subGenre: "ジャンル2_a", title: "回転カン", subTitle: "" },
      //   { productId: "37", price: 114, subGenre: "ジャンル2_b", title: "カニカン", subTitle: "" },
      //   { productId: "38", price: 137, subGenre: "ジャンル3_a", title: "ナスカン (丸カン付き)", subTitle: "" },
      // ];
    }


    getGenreList(){
      // すでに作成済みの場合はそれを返す
      if( !this.itemList && !this.genreList ){
        return this.genreList;
      }
    }

    getOptionDataForProductId( productId ){
      return this.itemList.filter((item)=>{return item.productId == productId})[0];
    }

    // APIからオプション品の一覧を取得する
    async apiGetOptionList(){
      return await APIConnect.E02();
    }

    // csvからオプションデータのテキストを取得する
    async getCSVOptionData(){
      return new Promise((resolve)=>
      {
        // CSVファイルを取得
        let csv = new XMLHttpRequest();
        csv.open("GET", "option/option_data.csv", false);
        csv.setRequestHeader('Pragma', 'no-cache');
        csv.setRequestHeader('Cache-Control', 'no-cache');
        csv.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT');
        csv.onreadystatechange = function (){
          if(csv.readyState === 4){
             if(csv.status === 200){
                resolve(csv.responseText)
             }else{
                alert("データ取得失敗")
             }
          }
        }
        csv.send(null);
      });
    }

}
export { OptionManager }